export const evaluationsText = ['basicParent/evaluationText1', 'basicParent/evaluationText2', 'basicParent/evaluationText3'];

export const evaluationsTextZ = ['basicParent/evaluationTextZ1', 'basicParent/evaluationTextZ2', 'basicParent/evaluationTextZ3'];

export const emojis = ['assets/img/emojis/green-emoji.png', 'assets/img/emojis/yellow-emoji.png', 'assets/img/emojis/red-emoji.png'];
